import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { useGetActiveProfileName, useAsyncState } from '@/utils/hooks';
import TermsModal from './TermsModal';
import { getTerms, acceptTerms } from '@/services/terms';

interface TermsModalWrapperProps {
    preview?: boolean;
}

const isShowroomRoute = () => {
    const base = (import.meta.env.BASE_URL as string) || '/';
    return window.location.pathname.startsWith(`${base}showroom/`);
};

// const supportedLocales = ['nb-NO'];

const TermsModalWrapper: React.FC<TermsModalWrapperProps> = ({ preview }) => {
    // const isBuyer = useIsBuyer();
    const [checked, setChecked] = useState(false);
    
    const user = useSelector((state: IState) => state.global.user);
    const activeProfile = useSelector((state: IState) => state.global.activeProfile);
    const profileId = activeProfile?.id ?? null;

    const [terms, , reloadTerms] = useAsyncState(
        () => ((user?.isLoggedIn && profileId) ? getTerms(profileId) : Promise.resolve(null)),
        [user, profileId],
        null
    );
    const profileName = useGetActiveProfileName();
    const [saving, setSaving] = useState(false);

    const acceptRequired = terms && (terms.bygrTermsAcceptRequired || terms.sellerTermsAcceptRequired);

    if (preview || !user || !user.isLoggedIn || !terms || !acceptRequired) {
        return null;
    }
    // The public showroom is anonymous and must not pop up the terms-of-service modal even when
    // Redux still holds a logged-in user from a previous session in the same browser.
    if (isShowroomRoute()) {
        return null;
    }

    const onAcceptClick = async () => {
        setSaving(true);
        await acceptTerms(profileId);
        await reloadTerms();
        setSaving(false);
        // await loadUser();
    };

    return (
        <TermsModal
            checked={checked}
            isOpen={true}
            isSaving={saving}
            onAcceptClick={onAcceptClick}
            onCheckChange={setChecked}
            profileName={profileName}
            terms={terms}
        />
    );
};

export default TermsModalWrapper;
